import {call, put} from "typed-redux-saga";
import {IError, ISagaAction} from "modules/types";
import Api from "modules/utils/Api";
import {IContactPayload, postContactFailed, postContactSuccess} from "modules/actions";

export const postContactSaga = function* ({payload}: ISagaAction<IContactPayload>) {
	try {
		yield* call(Api.Contact.contact, payload);
		yield* put(postContactSuccess());
	} catch (e) {
		yield* put(postContactFailed(e as IError));
	}
};
